import React from 'react';

/**
 * Marca da Sandra Tur (logo + wordmark).
 * Não envolve em <Link> para evitar âncoras aninhadas — os pais já provêm o link.
 */
export function Brand({ showText = true, size = 36, className = '', textClassName = '' }) {
  return (
    <span className={`flex items-center gap-2 ${className}`} data-testid="brand">
      <span
        className="rounded-full bg-white ring-1 ring-border/40 overflow-hidden flex items-center justify-center shrink-0 shadow-sm"
        style={{ height: size, width: size }}
      >
        <img
          src="/sandra-tur-logo.jpg"
          alt="Sandra Tur"
          className="h-full w-full object-contain"
          loading="eager"
        />
      </span>
      {showText && (
        <span className={textClassName || 'font-display text-lg font-semibold tracking-tight'}>
          Sandra Tur
        </span>
      )}
    </span>
  );
}
